module.exports = __webpack_public_path__ + "static/img/SearchTrade.7b1de3b0.png";